import { render, staticRenderFns } from "./HumanCapitalAcquisitionRateReport.vue?vue&type=template&id=28ae9c74&scoped=true&"
import script from "./HumanCapitalAcquisitionRateReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAcquisitionRateReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalAcquisitionRateReport.vue?vue&type=style&index=0&id=28ae9c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae9c74",
  null
  
)

export default component.exports